import { useTranslation } from 'react-i18next'
import { SOCIAL_ICONS } from './socialIcons.js'

/** "Also live on YouTube / Twitch / Kick" while the server restreams this feeder. */
export default function LiveOn({ links }) {
  const { t } = useTranslation()
  const shown = (links ?? []).filter((l) => l.url)
  if (!shown.length) return null
  return (
    <div className="flex flex-wrap items-center gap-2.5 text-[15px] font-bold text-muted">
      {t('live.alsoOn')}
      {shown.map(({ platform, url }) => {
        const icon = SOCIAL_ICONS[platform]
        return (
          <a
            key={platform}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 rounded-full border-[1.5px] border-edge bg-surface px-3.5 py-1.5 font-extrabold text-ink no-underline hover:border-ink"
          >
            {icon ? (
              <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                <path d={icon.path} fill={icon.color} />
              </svg>
            ) : null}
            {icon?.title ?? platform}
          </a>
        )
      })}
    </div>
  )
}
